const cashFundCardsSize = {
  sm: {
    width: 380,
    height: 374,
  },
  belowSm: {
    width: 190,
    height: 187,
  },
};

export const babyRegistryPageData = {
  seo: {
    title: 'Baby Registry | Your All-in-One Baby Registry - Joy',
    content: 'Everything for little moments',
  },
  hero: {
    eyebrow: 'The All-in-One Baby Registry',
    title: 'Everything for',
    getStarted: 'Get Started',
    findARegistry: 'Find a Registry',
  },
  shopRegistry: {
    subTitle: 'Discover trusted baby brands beloved by parents.',
    shopTitle: 'Shop Baby Registry by Department',
  },
  completionDiscount: {
    background: 'baby-registry/completion-discount/bg-img-v2.jpg',
    mobileBackground: '/baby-registry/completion-discount/bg-img-mobile.jpg',
    eyebrow: '20% Completion Discount',
    title: 'Register now, save later.',
    body: 'Joy has the biggest baby registry completion discount around because your baby deserves the very best.',
  },
  universalRegistry: {
    bgTopLeft: 'baby-registry/universal-reg/thread-1.svg',
    bgBottomRight: 'baby-registry/universal-reg/thread-2.svg',
    eyebrow: 'Your Universal Baby Registry',
    title: 'Welcome to your<br /> universal baby registry.',
    body: 'Add items from the Joy Shop or any store you like and provide gift-givers one place to shop.',
    registryTypeGifts: 'Baby Gifts',
    registryTypeCash: 'Cash Funds',
    registryTypeBabymoon: 'Babymoons',
    logos: [
      {
        width: 100,
        src: 'baby-registry/universal-reg/logos/logo-amazon.svg',
        alt: 'Amazon baby registry',
      },
      {
        width: 100,
        src: 'baby-registry/universal-reg/logos/logo-target.svg',
        alt: 'Target baby registry',
      },
      {
        width: 100,
        src: 'baby-registry/universal-reg/logos/logo-pottery-barn-kids.svg',
        alt: 'Pottery Barn kids',
      },
      {
        width: 100,
        src: 'baby-registry/universal-reg/logos/logo-crate-and-kids.svg',
        alt: 'Crate and kids',
      },
      {
        width: 50,
        src: 'baby-registry/universal-reg/logos/logo-babylist.png',
        alt: 'BabyList baby registry',
      },
    ],
  },
  shopSearch: {
    title: 'Shop for baby with Joy.',
    subTitle: 'Gifts including baby gear, babymoons, cash funds, and more.',
    placeHolder: 'Search products and brands',
    submitLabel: 'Search',
  },
  giftingGroup: {
    gift: {
      eyebrow: 'Group Gifting',
      title: 'The guilt-free registry.',
      body: 'Don’t stress about registering for bigger items. With group gifting, friends and family can contribute how much they want.',
    },
    thanks: {
      eyebrow: 'Thank You Notes',
      title: 'Gratitude made easy.',
      body: 'We’ll keep a list of who sent what so you can send free, online thank you notes right from your Gift Tracker.',
    },
    shipAnywhere: {
      eyebrow: 'Ship Anywhere',
      title: 'Shower or sprinkle,</br> ship it where you need it.',
      body: 'Tell us where to send your baby registry gifts and we’ll ship them there for free.',
      note: '(Some exclusions apply.)',
      src: 'baby-registry/ship-anywhere/ship-anywhere.jpg',
      srcMobile: '/baby-registry/ship-anywhere/bg-img-mobile.jpg',
    },
  },
  cashFunds: {
    eyebrow: 'Zero-Fee Cash Funds',
    title: 'Save a lot for your little one.',
    body: 'With no hidden fees, zero-fee cash funds are a gift idea everyone will go gaga over.',
    src: 'baby-registry/cash-funds/funds-bg-v6.jpg',
    srcMobile: '/baby-registry/cash-funds/funds-bg-mobile.jpg',
    getStarted: 'Get Started',
    cardTitle: 'Just use your favorite payment provider, including:',
  },
  customCashFund: {
    eyebrow: 'Customized Cash Funds',
    title: 'Plan for the parenthood journey.',
    body: 'Create a cash fund for college, diapers, meals, or anything to make life a little smoother.',
    getStarted: 'Get Started',
    productList: [
      {
        image: { url: 'baby-registry/cash-funds/fund-cards/doula-v3.png' },
        ...cashFundCardsSize,
      },
      {
        image: { url: 'baby-registry/cash-funds/fund-cards/parental-leave-v3.png' },
        ...cashFundCardsSize,
      },
      {
        image: { url: 'baby-registry/cash-funds/fund-cards/college-v3.png' },
        ...cashFundCardsSize,
      },
      {
        image: { url: 'baby-registry/cash-funds/fund-cards/diaper-v3.png' },
        ...cashFundCardsSize,
      },
      {
        image: { url: 'baby-registry/cash-funds/fund-cards/babymoon-v3.png' },
        ...cashFundCardsSize,
      },
      {
        image: { url: 'baby-registry/cash-funds/fund-cards/meals-v3.png' },
        ...cashFundCardsSize,
      },
    ],
  },
  joyButtonSection: {
    eyebrow: 'The Joy Quick Add Button',
    title: 'Add gifts from any website, instantly.',
    body: 'Browse any online store and easily add any item you like to your baby registry.',
  },
  faqList: {
    title: 'Still have questions?',
  },
  abcSectionData: {
    title: 'Let’s take the first step together.',
    content: 'We’re here for you with expert advice and around-the-clock customer support.',
    link: {
      label: 'Create Baby Registry',
    },
    video: {
      title: 'Dancing Shoes Video',
      embedUrl: 'https://player.vimeo.com/video/844721550?h=a171b95e65&badge=0&player_id=0&app_id=58479',
      posterUrl: 'baby-registry/video-footer/placeholder.jpg',
    },
  },
} as const;
